module.exports = __webpack_public_path__ + "static/media/features-split-image-06.9d707c4d.png";